export default {"src":"/_next/static/media/img-payment_survey_coplete.1c13fa1f.svg","height":63,"width":64,"blurWidth":0,"blurHeight":0};